// Find one good representative emoji to test. Ideally it should have color in the center.
// For some inspiration, see: https://about.gitlab.com/blog/2018/05/30/journey-in-native-unicode-emoji/
export const versionsAndTestEmoji = {
  '😃': 0.6,
  '😐️': 0.7,
  '😀': 1,
  '👁️‍🗨️': 2,
  '🤣': 3,
  '👱‍♀️': 4,
  '🤩': 5,
  '🥰': 11, // smiling face with hearts
  '🥻': 12, // sari
  '🧑‍🦰': 12.1, // person: red hair
  '🥲': 13 // smiling face with tear
}
